import { render, staticRenderFns } from "./BaseReport.vue?vue&type=template&id=50292d48&"
import script from "./BaseReport.vue?vue&type=script&lang=js&"
export * from "./BaseReport.vue?vue&type=script&lang=js&"
import style0 from "./BaseReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports